export default {
  "languages": {
    "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["English"])},
    "it": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Italiano"])}
  },
  "labels": {
    "target-value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Target Value"])},
    "min-value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Min"])},
    "max-value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Max"])},
    "avg-value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Average"])},
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
    "continue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continue"])},
    "update": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Update"])},
    "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back"])}
  },
  "strings": {
    "chart-type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chart Type"])},
    "chart-type-subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select a chart type"])},
    "chart-type-qualitative-hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["For qualitative KPIs, only categorical charts are available"])},
    "chart-category-distribution": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Category Distribution"])},
    "chart-target-category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Target Category"])},
    "chart-categories": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Categories"])},
    "chart-frequency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Frequency"])},
    "dashboard-kpi-visualization-chart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["KPI Visualization Chart"])},
    "dashboard-suggestion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select a chart type with which you want to display the KPI values"])}
  },
  "errors": {
    
  }
}